const DEFAULT_STORAGE_CDN_BASE_URL = 'https://cdn.buildmate.online';

/** CDN base URL from webapp env (REACT_APP_STORAGE_CDN_BASE_URL). */
export function getStorageCdnBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_STORAGE_CDN_BASE_URL?.trim();
  const base = fromEnv || DEFAULT_STORAGE_CDN_BASE_URL;
  return base.replace(/\/$/, '');
}

/** Storage path → full CDN URL. data: and http(s): refs are returned unchanged. */
export function resolveStorageUrl(ref: string): string {
  const r = (ref || '').trim();
  if (!r) return r;
  const lower = r.toLowerCase();
  if (lower.startsWith('data:') || lower.startsWith('http://') || lower.startsWith('https://')) {
    return r;
  }
  return `${getStorageCdnBaseUrl()}/${r.replace(/^\//, '')}`;
}
